export const zIndex = {
    overMap: {
        value: 2,
    },
    overMapMarkers: {
        value: 10000,
    },
    toast: {
        value: 2000000000,
    },
};
